import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Constants } from '../lib/const/constants';
import { ArrowLeft, ArrowRight } from 'lucide-react';

function BeneficiaryTypes() {
  const navigate = useNavigate();
  const location = useLocation();
  const paramsdata = location.state;
  const workspaces = JSON.parse(sessionStorage.getItem('login_workspaces'));
  const account_type = workspaces?.[0]?.type;
  // console.log('account_type', account_type);
  const currency = paramsdata?.currency;
  const node = paramsdata?.node;
  // console.log('Beneficiary Types Node', node);
  const Nav_node = paramsdata?.Nav_node;
  const transferflowamount = paramsdata?.transferflowamount;
  const currencyid =
    paramsdata?.currencyid ?? paramsdata?.meta?.country_id ?? 0;
  const nodeType = location.state?.nodeType || '';
  const sendmoneynode =
    location.state?.sendmoneynode ?? location.state?.sendmoney_node;
  const routeName =
    paramsdata?.routeName != '' && paramsdata?.routeName != null
      ? paramsdata.routeName
      : '';

  const buyAmount = location.state?.buyAmount;
  const exchangeRate = location.state?.exchangeRate;
  const contactId = location.state?.contactId;
  const from_currency = location.state?.from_currency;
  const from_amount = location.state?.from_amount;
  const total_amount = location.state?.total_amount;
  const amount = location.state?.amount;
  const balance = location.state?.balance;
  const sendmoney_Nav_node = location.state?.sendmoney_Nav_node;
  const transfer_fee = location.state?.transfer_fee;
  const service_fee = location.state?.service_fee;
  const sbnode = 2;

  const [, setBalances] = useState([]);
  const [, setusedBalances] = useState([]);
  const [selectedType, setSelectedType] = useState(null);

  // console.log('currencyid', currencyid);
  // console.log('paramsdata', paramsdata);
  // console.log('nodeType', nodeType);
  // console.log('location', location);
  // console.log('node', node);
  // console.log('sbnode', sbnode);

  useEffect(() => {
    getBalances();
  }, []);

  const getBalances = async () => {
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');
    try {
      const resp = await axios.get(
        Constants.BASE_URL +
          'API-FX-231-GET-WALLET-BALANCES/' +
          login_workspaces_id,
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );
      const balArray = Object.values(resp.data);
      setusedBalances(resp.data.used_balances);
      balArray.pop();
      balArray.pop();
      balArray.pop();
      balArray.pop();
      if (balArray.length > 0) {
        setBalances(balArray);
      }
    } catch (err) {
      console.log(err.response?.data || err);
    }
  };

  const sharedState = {
    currency,
    transferflowamount,
    currencyid,
    balance: paramsdata?.balance,
    routeName,
    nodeType: nodeType || '',
    node,
    Nav_node,
    sendmoneynode,
    buyAmount,
    exchangeRate,
    contactId,
    from_currency,
    from_amount,
    sendmoney_Nav_node,
    sbnode,
    transfer_fee,
    service_fee,
    total_amount,
  };

  const handleContinue = () => {
    if (selectedType === 'individual') {
      navigate('/SelfAccount', { state: sharedState });
    } else {
      navigate('/BusinessAccount', { state: sharedState });
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&display=swap');

        * {
          box-sizing: border-box;
        }

        .btype-root {
          font-family: 'DM Sans', sans-serif;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          width: 100%;
          min-height: 100vh;
          padding: 40px 16px 60px;
          background-color: #ffffff;
          background-image: linear-gradient(to bottom, #f8fafc 0%, #eff6ff4d 50%, #eef2ff66 100%);
          background-repeat: no-repeat;
          background-size: cover;
        }

        .btype-card {
          width: 100%;
          max-width: 580px;
        }

        /* ── Back button ── */
        .btype-back-btn {
          display: flex;
          align-items: center;
          gap: 10px;
          background: none;
          border: none;
          padding: 0;
          margin-bottom: 16px;
          font-size: 16px;
          font-weight: 700;
          color: #1D2338;
          cursor: pointer;
        }

        .btype-back-btn svg {
          flex-shrink: 0;
        }

        /* ── Title ── */
        .btype-title {
          font-size: 26px;
          font-weight: 700;
          color: #394784;
          text-align: center;
          letter-spacing: -0.4px;
          margin: 0 0 32px;
          line-height: 1.3;
        }

        /* ── Option cards ── */
        .btype-options {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-bottom: 28px;
        }

        .btype-option {
          position: relative;
          background: #fff;
          border: 1.5px solid #e2e8f0;
          border-radius: 16px;
          padding: 32px 20px 28px;
          cursor: pointer;
          text-align: center;
          transition: border-color 0.2s, box-shadow 0.2s;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          outline: none;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
          width: 100%;
        }

        .btype-option:hover {
          border-color: #f0a96a;
          box-shadow: 0 4px 18px rgba(232, 134, 58, 0.1);
        }

        .btype-option.selected {
          border: 2px solid #e8863a;
          box-shadow: 0 4px 20px rgba(232, 134, 58, 0.18);
          background: #fffaf6;
        }

        /* ── Checkmark badge ── */
        .btype-check {
          position: absolute;
          top: 12px;
          right: 12px;
          width: 24px;
          height: 24px;
          background: #e8863a;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transform: scale(0.5);
          transition: opacity 0.18s, transform 0.18s;
        }

        .btype-option.selected .btype-check {
          opacity: 1;
          transform: scale(1);
        }

        .btype-check svg {
          width: 13px;
          height: 13px;
          display: block;
        }

        /* ── Icon wrapper ── */
        .btype-icon-wrap {
          width: 64px;
          height: 64px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 4px;
        }

        .btype-icon-wrap img {
          width: 56px;
          height: 56px;
          object-fit: contain;
        }

        /* ── Card text ── */
        .btype-option-title {
          font-size: 18px;
          font-weight: 700;
          color: #1e2d55;
          line-height: 1.3;
        }

        .btype-option-desc {
          font-size: 13px;
          color: #7a8197;
          line-height: 1.55;
          font-weight: 400;
          max-width: 180px;
        }

        /* ── Continue button ── */
        .btype-continue-btn {
          width: 100%;
          height: 56px;
          padding: 12px 20px;
          border-radius: 12px;
          border: none;
          background: #D1D5DB;
          color: #FFFFFF;
          font-size: 16px;
          font-weight: 700;
          cursor: not-allowed;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          box-shadow: 0px 8px 20px 0px #0000001F;
          transition: opacity 0.15s;
        }

        .btype-continue-btn:not(:disabled) {
          background: #D26521;
          cursor: pointer;
        }

        .btype-continue-btn:not(:disabled):hover {
          opacity: 0.88;
        }

        /* ── Responsive ── */
        @media (max-width: 420px) {
          .btype-options {
            grid-template-columns: 1fr 1fr;
            gap: 12px;
          }

          .btype-option {
            padding: 24px 12px 20px;
          }

          .btype-option-desc {
            font-size: 12px;
            max-width: 140px;
          }

          .btype-title {
            font-size: 22px;
          }
        }
      `}</style>

      <div className="btype-root">
        <div className="btype-card">
          {/* Back button */}
          <button
            className="btype-back-btn"
            onClick={() => {
              if (sendmoney_Nav_node) {
                navigate('/Choosepayment',{ state: sharedState });
              }
              else if (sbnode && account_type === 'individual') {
                navigate('/SelectCurrencyForBeneficiary');
              } else if (node && account_type === 'business') {
                navigate('/SelectCurrencyForBeneficiary');
              } else {
                navigate('/sendMoney', {
                  state: {
                    currency,
                    transferflowamount: amount,
                    currencyid,
                    balance,
                  },
                });
              }
            }}
          >
            <ArrowLeft className='w-5 h-5 -mr-1.5' />
            Back
          </button>

          {/* Title */}
          <h2 className="btype-title">Select Beneficiary Type</h2>

          {/* Cards */}
          <div className="btype-options">
            {/* Individual */}
            <button
              className={`btype-option${selectedType === 'individual' ? ' selected' : ''}`}
              onClick={() => setSelectedType('individual')}
            >
              <div className="btype-check">
                <svg viewBox="0 0 13 13" fill="none">
                  <path
                    d="M2 6.5L5.2 9.5L11 3.5"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="btype-icon-wrap">
                <img
                  src={
                    selectedType === 'individual'
                      ? '/individual-icon-active.png'
                      : '/individual-icon.png'
                  }
                  alt="Individual"
                />
              </div>
              <span className="btype-option-title">Individual</span>
              <span className="btype-option-desc">
                Personal payments to friends, family, or individuals.
              </span>
            </button>

            {/* Business */}
            <button
              className={`btype-option${selectedType === 'business' ? ' selected' : ''}`}
              onClick={() => setSelectedType('business')}
            >
              <div className="btype-check">
                <svg viewBox="0 0 13 13" fill="none">
                  <path
                    d="M2 6.5L5.2 9.5L11 3.5"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="btype-icon-wrap">
                <img
                  src={
                    selectedType === 'business'
                      ? '/business-icon-active.png'
                      : '/business-icon.png'
                  }
                  alt="Business"
                />
              </div>
              <span className="btype-option-title">Business</span>
              <span className="btype-option-desc">
                Payments to companies, Welfare Organizations, business.
              </span>
            </button>
          </div>

          {/* Continue */}
          <button
            className="btype-continue-btn"
            onClick={handleContinue}
            disabled={!selectedType}
          >
            <span>Continue</span>
            <ArrowRight className='w-5 h-5 -ml-2.5' />
          </button>
        </div>
      </div>
    </>
  );
}

export default BeneficiaryTypes;